import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../common/Common';
import { getCompanyListFulfilled } from './commonSliceFunction';
import { TARGET_YEAR_API } from '../../common/data';

const initialState = {
  companyList: [],
  selectedCompany: {
    htmComCd: '',
    htmComNm: '',
  },

  bankList: [],

  isMagam: false, //마감여부
  isCertify: false, //인증여부
  isMagamChecked: false, //마감 api 탔는지
  isCertifyChecked: false, //인증 api 탔는지

  magamFlag: 'O',

  workMonthData: {},
  callcenter: '', //콜센터번호
  msgData: {}, //개인알림
  agree: false, //약관동의
  yaStart: false, //연말정산 시작 유무
  compassCheck: false, //비밀번호 체크

  isDataModified: false, //데이터 수정여부(입력한 내용이 저장X~~ 띄우는 용도)

  resultDataView: [], //메인용 결과조회

  yaPlan: null, //연말정산 스케줄

  isTaxChangePer: false, //세액변경알림
  taxChangePer: [], //세액변경알림
};
//은행목록 가져오기
export const getBankList = createAsyncThunk('common/getBankList', async () => {
  const response = APIRequest(`/${TARGET_YEAR_API}/getBankList`, {});
  return response;
});

//마감
export const getMagamFlag = createAsyncThunk('common/getMagamFlag', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/magamFlag`);
  return response;
});

//인증
export const getCertifyFlag = createAsyncThunk('common/getCertifyFlag', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getCertifyFlag`);
  return response;
});

//일한월
export const getWorkMonth = createAsyncThunk('common/getWorkMonth', async () => {
  const response = await APIRequest(`/YA/getWorkMonth`);
  return response;
});

//yaStart
export const getYAStart = createAsyncThunk('common/getYAStart', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/yaStart`);
  return response;
});

//주택요건 체크안하고 넘어가는거(PC용임)
export const checkHouseNext = createAsyncThunk('common/checkHouseNext', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}PDF/checkHouseNext`);
  return response;
});

//주택요건 체크안하고 넘어가는거(이게 모바일용)
export const setHouseChkAfterCalc = createAsyncThunk('common/setHouseChkAfterCalc', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/setHouseChkAfterCalc`);
  return response;
});

//전액공제 조건 확인
export const checkPassNext = createAsyncThunk('common/checkPassNext', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}PDF/checkPassNext`);
  return response;
});

//세액계산호출
export const setCalc = createAsyncThunk('common/setCalc', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/setCalc`);
  return response;
});

//결정세액확인
export const getHtm062 = createAsyncThunk('common/getHtm062', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}PDF/getHtm062`);
  return response;
});

//비밀번호 체크
export const getHtmComPassCheck = createAsyncThunk('common/getHtmComPassCheck', async () => {
  const response = await APIRequest('/YA/getHtmComPassCheck');
  return response;
});

//동의하기 체크
export const getMobileAgree = createAsyncThunk('common/getMobileAgree', async () => {
  const response = await APIRequest('/YA/getMobileAgree');
  return response;
});

//근로자 연말정산 시작 유무
export const getYaStartYN = createAsyncThunk('common/yaStartYN', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/yaStartYN`);
  return response;
});

//연말정산 스케줄
export const getYAPlan = createAsyncThunk('common/getYAPlan', async () => {
  const response = await APIRequest('/YA/getYAPlan');
  return response;
});

//메세지
export const getCheckMsg = createAsyncThunk('common/getCheckMsg', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getCheckMsg`);
  return response;
});

//콜센타 번호
export const getCallCenter = createAsyncThunk('common/getCallCenter', async () => {
  const response = await APIRequest('/YA/getCallCenter');
  return response;
});

//약관동의
export const setMobileAgree = createAsyncThunk('common/setMobileAgree', async () => {
  const response = await APIRequest('/YA/setMobileAgree');
  return response;
});

//인사정보체크
export const checkYaInsaPer = createAsyncThunk('common/checkYaInsaPer', async () => {
  const response = await APIRequest('/YA/checkYaInsaPer');
  return response;
});

//메인용 결과상세
export const getResultDataView = createAsyncThunk('resultQuery/getResultDataView', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getResultDataView`);
  return response;
});

//010오류
export const getTaxChanger = createAsyncThunk('common/getTaxChangePer', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getTaxChangePer`);
  return response;
});

/* Slice */
export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setSelectedCompany: (state, action) => {
      state.selectedCompany = {
        ...action.payload,
      };
    },
    setAgree: (state, action) => {
      state.agree = action.payload;
    },
    setIsDataModified: (state, action) => {
      state.isDataModified = action.payload;
    },
    setCloseDialog: (state, action) => {
      state.closeDialog = action.payload;
    },
    setYaStart: (state, action) => {
      state.yaStart = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getBankList.fulfilled, (state, action) => {
      console.log(action.payload);
      const { list } = action.payload;
      if (list) {
        state.bankList = [{ bankCd: '', bankNm: '선택하세요' }, ...list];
      }
    });
    builder.addCase(getMagamFlag.fulfilled, (state, action) => {
      console.log(action.payload);
      const { rFlag } = action.payload;
      if (rFlag && rFlag === 'O') {
        //마감아님
        state.isMagam = false;
      } else {
        //마감됨
        state.isMagam = true;
      }
      state.magamFlag = rFlag || '';
      state.isMagamChecked = true;
    });
    builder.addCase(getCertifyFlag.fulfilled, (state, action) => {
      const { htmCertifyFlag } = action.payload;

      if (!htmCertifyFlag || htmCertifyFlag == '') {
        state.isCertify = false;
      } else {
        //인증됨
        state.isCertify = true;
      }
      state.isCertifyChecked = true;
    });
    builder.addCase(getWorkMonth.fulfilled, (state, action) => {
      console.log('일했어요, ', action.payload);
      const { resultCode, resultData } = action.payload;
      if (resultCode === '1') {
        state.workMonthData = resultData;
      }
    });
    builder.addCase(getCheckMsg.fulfilled, (state, action) => {
      console.log('메세지, ', action.payload);
      state.msgData = action.payload;
    });
    builder.addCase(getCallCenter.fulfilled, (state, action) => {
      console.log('콜센터, ', action.payload);
      const { callcenter } = action.payload;
      state.callcenter = callcenter || '';
    });
    builder.addCase(setMobileAgree.fulfilled, (state, action) => {
      console.log('동의하기, ', action.payload);
      const { resultCode } = action.payload;
      state.agree = Number(resultCode) === 1 ? true : false;
    });
    builder.addCase(getYaStartYN.fulfilled, (state, action) => {
      console.log('연말정산 시작 유무, ', action.payload);
      const { resultCode } = action.payload;
      state.yaStartYN = Number(resultCode) === 1 ? true : false;
    });
    builder.addCase(getHtmComPassCheck.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      state.compassCheck = Number(resultCode) !== 1 ? true : false;
    });
    builder.addCase(getResultDataView.fulfilled, (state, action) => {
      console.log('메인용 결과상세, ', action.payload);
      state.resultDataView = action.payload;
    });
    builder.addCase(getTaxChanger.fulfilled, (state, action) => {
      const { resultCode, boyangList } = action.payload;
      console.log('boyangList >>', boyangList);
      if (resultCode == '1') {
        state.isTaxChangePer = true;
        console.log('boyangList >>', boyangList);
        //본인
        const person = boyangList.find(item => item.htm002 == '0')?.htm038;
        //부양가족
        const dependents = boyangList.filter(item => item.htm002 != '0').map(item => item.htm038);

        console.log('person >>', person);
        console.log('dependents>', dependents);

        state.taxChangePer = { person, dependents };
      } else {
        state.isTaxChangePer = false;
      }
    });
    builder.addCase(getYAPlan.fulfilled, (state, action) => {
      console.log('연말정산 스케줄, ', action.payload);
      state.yaPlan = action.payload;
    });
  },
});
export const { setSelectedCompany, setAgree, setIsDataModified, setCloseDialog, setYaStart } =
  commonSlice.actions;

export default commonSlice.reducer;
